'use client';

import { useEffect, useState } from 'react'; // Importing useState for state management
import { useDispatch, useSelector } from 'react-redux'; // Importing Redux's useSelector hook for state management
import {
  selectDynSess,
  selectIsFurniture,
  selectIsGSAUser,
  selectIsLoggedIn,
  selectIsSessionInfoAvailable,
} from '@next-app/lib/features/InitSelectors';
import { PropsWithChildren } from 'react';
import { fetchCheckoutDetails } from '@next-app/utils/CheckoutHelper';
import { selectReloadLoadCheckoutDetails } from '@next-app/lib/features/checkout/CheckoutSelector';
import { setReloadLoadCheckoutDetails } from '@next-app/lib/features/checkout/CheckoutSlice';

const LoadCheckoutDetails = ({ children }: PropsWithChildren) => {
  const dynSessConf = useSelector(selectDynSess);
  const isSessionInfoAvailable = useSelector(selectIsSessionInfoAvailable);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const isFurniture = useSelector(selectIsFurniture);
  const reloadCheckoutDetails = useSelector(selectReloadLoadCheckoutDetails);
  const isGSAUser = useSelector(selectIsGSAUser);

  const [containerClass, setContainerClass] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    if (isSessionInfoAvailable || reloadCheckoutDetails) {
      fetchCheckoutDetails({ dynSessConf, dispatch, isFurniture });
      if (reloadCheckoutDetails) dispatch(setReloadLoadCheckoutDetails(false));
    }

    setContainerClass(isFurniture && !isGSAUser ? 'f-style' : '');
  }, [
    isSessionInfoAvailable,
    isLoggedIn,
    isFurniture,
    reloadCheckoutDetails,
    isGSAUser,
  ]);

  return <div className={containerClass}>{children}</div>;
};

export default LoadCheckoutDetails;
